










import Vue from 'vue'
import { createScene, destroyScene } from '@/common/babylonJsInstance'
import  Spinner  from '@/common/components/Spinner.vue'

export default Vue.extend({
  name: 'Scene3DViewer',
  components: {
    Spinner
  },
  props: {
    modelUrl: {
      type: String,
      required: true
    },
    modelFormat: {
      type: String,
      required: true
    },
    modelTexture: {
      type: String,
      required: true
    }
  },
  mounted() {
    const renderCanvas = this.$refs.renderCanvas as HTMLCanvasElement
    const renderLoader = document.getElementsByClassName('sw-Spinner')[0] as HTMLElement
    if (renderCanvas) {
      createScene(renderCanvas, renderLoader, this.modelUrl, this.modelFormat, this.modelTexture)
    }
  },
  destroyed() {
    destroyScene()
  }
})
